document.addEventListener("DOMContentLoaded", function () {
  var FREE_THRESHOLD = 2; // matches the $2.00 threshold used elsewhere on the storefront

  function applyFreeLabel() {
    document
      .querySelectorAll(".upcart-item-price, .upcart-upsell-item-price")
      .forEach(function (el) {
        // Don't touch it twice
        if (el.getAttribute("data-free-applied") === "true") return;

        var text = el.textContent || "";
        var value = parseFloat(text.replace(/[^0-9.,]/g, "").replace(",", "."));

        if (!isNaN(value) && value <= FREE_THRESHOLD) {
          el.setAttribute("data-original-text", text);
          el.textContent = "FREE";
          el.setAttribute("data-free-applied", "true");
        }
      });
  }

  // Run once on load
  applyFreeLabel();

  // UpCart re-renders its drawer via AJAX on cart changes, so watch for that
  var observer = new MutationObserver(function () {
    applyFreeLabel();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});
